<template lang="html">
  <div>
    <boxModule
      v-for="(c, index) of modules"
      :key="'module-'+index"
      :title="c.title"
      :description="c.description"
      :icon="c.icon"
      :description-padding="descriptionPadding"
    />
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'ListModules',
  props: {
    company: {},
    portal: {},
    mode: {},
    description: {},
    descriptionPadding: { type: String, default: '20' },
  },
  data() {
    return {
      modules: [],
    };
  },
  created() {
    switch (this.mode.toLowerCase()) {
      case 'all':
        this.modules = this.company.json.module;
        break;
      case 'public':
        this.modules = this.company.json.module.filter(i => _.get(i, 'role.showLogin') === true || _.get(i, 'role.showLogin') === 'true');
        break;
      default:
        this.modules = this.company.json.module.filter(i => _.has(i, 'role.groups') && i.role.groups.filter(g => g.toLowerCase() == this.mode));
        break;
    }
  },
};
</script>

<style lang="scss">

</style>
